"use strict";
/*
    Replaces windows end of lines with unix eol
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixEOL = void 0;
function fixEOL(text) {
    return text.replace(/(\r?\n)|(\r\n?)/g, "\n");
}
exports.fixEOL = fixEOL;
